import { createGlobalStyle } from 'styled-components';
import { normalize } from 'polished';

export const GlobalStyles = createGlobalStyle`
  ${normalize()}

  html [type=button] {
    -webkit-appearance: unset;
  }
  [type=button] {
    -webkit-appearance: button;
  }

  html {
    box-sizing: border-box;
    font-size: 62.5%;
  }

  body {
    ${({ theme }) => ({
      fontFamily: theme.fontFamilys.jp,
      fontWeight: theme.fontWeights.normal,
      fontSize: theme.fontSizes.m,
      color: theme.fontColors.default,
      lineHeight: theme.lineHeights.default,
    })}
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  img {
    vertical-align: bottom;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  /* mieruka */
  #mieruca_heatmap_popup .mieruca-hm-popup-inner{
    max-width:340px !important;
  }
`;
